import { ClientResponse, ClientResponseError } from "@/Common/Api/ClientResponse";
import { Guid } from "@/Common/Models/Guid";
import { FlowsheetTemplateClient } from "@/Flowsheets/Api/FlowsheetTemplatesClient";
import { useCommand, UseCommandOptions, UseCommandResult } from "./useCommand";

/**
 * Interface representing the options for the useDeleteFlowsheetTemplate hook.
 */
interface UseDeleteFlowsheetTemplateOptions extends UseCommandOptions<ClientResponse<void>, ClientResponseError> {
}

/**
 * Custom hook to delete a flowsheetTemplate.
 * @param useDeleteFlowsheetTemplateOptions - Options for the useDeleteFlowsheetTemplate hook.
 * @returns An object containing the deleteFlowsheetTemplate function and the mutation result.
 */
function useDeleteFlowsheetTemplate(useDeleteFlowsheetTemplateOptions?: UseDeleteFlowsheetTemplateOptions): UseCommandResult<ClientResponse, unknown, Guid> {
    async function command(flowsheetTemplateId: Guid): Promise<ClientResponse> {
        const response = await FlowsheetTemplateClient.deleteFlowsheetTemplate(flowsheetTemplateId);

        response.throwIfError();

        return response;
    }

    return useCommand(command, useDeleteFlowsheetTemplateOptions);
}

export default useDeleteFlowsheetTemplate;
